import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export default api;

export function fmtErr(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STATUS_COLORS = {
  new: "bg-sky-100 text-sky-800",
  auditing: "bg-amber-100 text-amber-800",
  pending_review: "bg-violet-100 text-violet-800",
  approved: "bg-emerald-100 text-emerald-800",
  sent: "bg-pine-light text-pine",
  rejected: "bg-red-100 text-red-700",
  failed: "bg-red-100 text-red-700",
  contacted: "bg-blue-100 text-blue-800",
  won: "bg-emerald-100 text-emerald-900",
  lost: "bg-gray-200 text-gray-600",
};
